import {Component, Input}           from '@angular/core';
import {NgbActiveModal}             from "@ng-bootstrap/ng-bootstrap";

import {RssmanagerItem}             from "../../../../services/feed/rssmanageritem";
import {Vendor}                     from "../../../../services/vendor/vendor";

import {isNullOrUndefined}          from "util";



@Component({
	selector: 'rssmanager-edit',
	templateUrl: './rssmanager-edit.component.html',
})


/**
 * The component that holds the modal window for editing an RssmanagerItem object.
 */
export class RssmanagerEditComponent {


	/**
	 * Create the object.
	 *
 	 * @param activeModal  This displays the modal edit window.
	 */
	constructor(

		public activeModal: NgbActiveModal

	) {}


	@Input() allCategories:string[];

	@Input() codes:string[];

	@Input() displays:string[];

	@Input() feedUrlStart:string;

	@Input() outputs:string[];

	@Input() item:RssmanagerItem;

	@Input() vendors:Vendor[];

	@Input() windowTitle:string;


	/**
	 * Add a category from the list.
	 *
	 * @param {string} category  The category to add.
	 */
	addCategory(category:string):void {

		let catarray:string[] = this.item.categories.split(',');

		if (0 === catarray.length || '' === catarray[0]) {

			this.item.categories = category;

		} else {

			this.item.categories = this.item.categories + ',' + category;

		}

	}

	/**
	 * Convert the user's click on a category to the appropriate
	 * value in the item.categories.
	 *
	 * @param {any} $event  Usually a mouse click on a checkbox.
	 */
	categoryClick($event: any): void {

		if($event.srcElement.checked) {

			this.addCategory($event.srcElement.dataset.id);

		} else {

			this.removeCategory($event.srcElement.dataset.id);

		}

	}


	/**
	 * Used when creating checkboxes; does the incoming
	 * category match one of the categories in the item?
	 *
	 * @param category    The category to check.
	 * @return {boolean} True, if the category is in the item, false otherwise.
	 */
	hasCategory(category:string):boolean {

		let catarray:string[] = this.item.categories.split(',');

		if (0 === catarray.length || '' === catarray[0]) {

			return false;

		}

		let found:string = catarray.find(obj => obj === category);
		return ! isNullOrUndefined(found);

	}


	/**
	 * Remove a category from the list.
	 *
	 * @param {string} category  The category to remove.
	 */
	removeCategory(category:string):void {

		let catarray:string[] = this.item.categories.split(',');
		let ndx:number = catarray.indexOf(category);

		if (-1 !== ndx) {

			catarray.splice(ndx, 1);
			this.item.categories = catarray.join(',');

		}

	}


}



// WEBPACK FOOTER //
// ./src/app/articles/feed/rssmanager/edit/rssmanager-edit.component.ts